import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const ToolbarButton = ({ active, onClick, children, type = "type" }) => (
    <OverlayTrigger
        placement={'bottom'}
        overlay={
            <Tooltip id={`tooltip-${type}`}>
                {type[0].toUpperCase() + type.slice(1).toLowerCase()}
            </Tooltip>
        }
    >
        <div>
            <button className={active ? 'active' : ''} onClick={onClick}>
                {children}
            </button>
        </div>
    </OverlayTrigger>
)

export default ToolbarButton
